import axios from '@/plugins/axios';
import { snackBarError } from '@/utils/snackbar';

export default {
	async fetchMaterialsAndSupplies({ commit }, placeId) {
		try {
			commit('setFetchLoading');
			const { data } = await axios(`/materialsAndSupplies/${placeId}`, { method: 'get' });
			commit('setMaterialsAndSupplies', data.materialsAndSupplies);
		} catch (error) {
			snackBarError(error)(commit);
		} finally {
			commit('setFetchLoading');
		}
	},
	async createMaterialsAndSupplies({ commit }, payload) {
		try {
			commit('setLoading');
			const { data } = await axios(`/materialsAndSupplies`, {
				method: 'post',
				data: payload,
			});
			commit('setMaterialsAndSupplies', data.materialsAndSupplies);
		} catch (error) {
			snackBarError(error)(commit);
		} finally {
			commit('setLoading');
		}
	},
	async deleteMaterialsAndSupplies({ commit }, id) {
		try {
			await axios(`/materialsAndSupplies/${id}`, {
				method: 'delete',
			});
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
};
